const sources = {
  '/assets/hero-community.jpg': {
    srcSet: '/assets/hero-community-960.webp 960w, /assets/hero-community-1600.webp 1600w',
    width: 1672,
    height: 941,
  },
  '/assets/project-cambodia.jpg': {
    srcSet: '/assets/project-cambodia-960.webp 960w, /assets/project-cambodia-1600.webp 1600w',
    width: 1672,
    height: 941,
  },
  '/assets/chanra-hai-2026.jpg': {
    srcSet: '/assets/chanra-hai-2026.webp 1163w',
    width: 1163,
    height: 1593,
  },
};

export default function ResponsiveImage({
  src,
  alt,
  className,
  eager = false,
  sizes = '(max-width: 900px) 100vw, 50vw',
}) {
  const source = sources[src];

  return (
    <picture>
      {source ? <source type="image/webp" srcSet={source.srcSet} sizes={sizes} /> : null}
      <img
        className={className}
        src={src}
        alt={alt}
        width={source?.width}
        height={source?.height}
        loading={eager ? 'eager' : 'lazy'}
        fetchpriority={eager ? 'high' : 'auto'}
        decoding="async"
      />
    </picture>
  );
}
